import { Divider } from "@mui/material";
import Grid from "@mui/material/Grid2";
import Title from "../../components/common/Title";
import { ValidationAlert } from "../../components/common/ValidationAlert";
import Layout from "../../components/layout/Layout";
import useAlert from "../../hooks/useAlert";
import ChangePassword from "./components/ChangePassword";
import MfaConfiguration from "./components/MfaConfiguration";

function Settings() {
  const { alertState, showAlert, closeAlert } = useAlert();

  return (
    <Layout>
      <ValidationAlert
        inputOpen={alertState.alertOpen}
        setInputClosed={closeAlert}
        severity={alertState.alertType}
        alertMessage={alertState.alertMsg}
      />

      {/* main content */}
      <Grid container direction="column" alignContent="center" justifyContent="center" sx={{ maxWidth: "100%" }}>
        {/* Title */}
        <Title text="Settings" sx={{ py: 2, px: 5, width: "100%", my: 5 }} />
        <Divider sx={{ mb: 8 }} />

        <Grid container direction="column" alignContent="center" justifyContent="flex-start" spacing={12} pb={12}>
          {/* Change Password component */}
          <ChangePassword showAlert={showAlert} />
          <Divider sx={{ mt: 2 }} />
          {/* MFA Configuration component */}
          <MfaConfiguration showAlert={showAlert} />
        </Grid>
      </Grid>
    </Layout>
  );
}

export default Settings;
